import React, {useMemo, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import useMouse from '@react-hook/mouse-position'

import {IAppState} from '../../../../store/models';

import useWindowDimensions from '../../../../hooks/useWindowDimensions';

import {zoomIn} from '../../../../store/actionsCreator/zoomActionCreators';


import {getHeightandWidthOfFlyerPage} from '../../SliderFor1Flyer/Flyer/utils'
import {IFlyerRuntimePage} from '../../../../dtos/flyer';
import {Box, Divider} from "@mui/material";
import {isMobile} from 'react-device-detect';
import Flyer from "../../SliderFor1Flyer/Flyer";

// const Flyer = lazy(() => import("../../SliderFor1Flyer/Flyer"))

interface IFlyer2Pages {
    page1: IFlyerRuntimePage,
    page2: IFlyerRuntimePage,
    page1Width: number,
    page2Width: number,
    page1Height: number,
    page2Height: number,
    isHebrewStyle: boolean;
    sliderRef?: any;
}

const Flyer2Pages: React.FC<IFlyer2Pages> = (props) => {

    const dispatch = useDispatch();
    const {zoomBranch, flyersBranch} = useSelector((state: IAppState) => state);
    const parentDivRef = useRef<HTMLDivElement>(null)

    const {isFullScreen} = useSelector((state: IAppState) => state.controlsBranch);
    const {height: windowHeight, width: windowWidth} = useWindowDimensions();
    // const isMobile = useMediaQuery("(max-width:767px)", { noSsr: true });

    const {height, width} = useMemo(
        () => getHeightandWidthOfFlyerPage(props.page1, windowHeight, windowWidth, isMobile, isFullScreen),
        [props.page1, windowHeight, windowWidth, isMobile, isFullScreen],
    );
    const isVerticalScrolling = flyersBranch.data?.pageLayoutPc === 2 || flyersBranch.data?.pageLayoutPc === 3;
    // const isOnePageOrientation: boolean = flyersBranch.data?.pageLayoutPc === 3;

    const direction = props?.isHebrewStyle && !isVerticalScrolling ? 'rtl' : 'ltr';

    const mouse = useMouse(parentDivRef, {
        enterDelay: 100,
        leaveDelay: 100,
    })

    const handleZoomClick = () => {
        if (!isFullScreen && !isVerticalScrolling) {
            let targetScale = zoomBranch.scale + 1;
            let globalMousePosition = mouse
            let mouseX = globalMousePosition.x!
            let mouseY = globalMousePosition.y!
            let currentWidth = width > height ? width : width * 2.0;
            let currentHeight = height;
            let percentX = (mouseX) / currentWidth
            let percentY = (mouseY) / currentHeight
            if (percentX >= 1) {
                percentX = 1
            } else if (percentX <= -1) {
                percentX = -1
            }

            if (percentY >= 1) {
                percentY = 1
            } else if (percentY <= -1) {
                percentY = -1
            }
            console.log("(x%,y%)=", percentX, percentY)
            console.log("(w%,h%)=", currentWidth, currentHeight)
            dispatch(zoomIn({x: 0, y: 0, pivotX: percentX, pivotY: percentY, scale: targetScale}));
        }
    }

    return (
        <Box
            ref={parentDivRef}
            onClick={() => {
                if (!isFullScreen && !isVerticalScrolling) {
                    handleZoomClick();
                }
            }}
            style={{
                height: '100%',
                display: 'flex',
                alignItems: "center",
                transformOrigin: `${zoomBranch.pivotX * 100.0}% ${zoomBranch.pivotY * 100.0}%`,
                transform: `scale(${1 + zoomBranch.scale}, ${1 + zoomBranch.scale})`,
                direction: direction,
                // border: `1px solid #bfbfbf`,
                padding: !isMobile ? `1px 1px 1px 1px` : 0
            }}
        >
            <Box
                sx={{
                    height: props.page1Height, width: props.page1Width,
                }}
            >
                <Flyer
                    page={props.page1}
                    handleInternalZooming={false}
                    sliderRef={props.sliderRef}
                    isSecondPage={isVerticalScrolling && props?.isHebrewStyle}
                />
            </Box>
            {
                (!props.page2.displayImageUrl.match(/(.jpg|.jpeg|.webp)/) && !props.page1.displayImageUrl.match(/(.jpg|.jpeg|.webp)/)) &&
                <Divider orientation="vertical" flexItem />
            }
            <Box
                sx={{
                    height: props.page1Height, width: props.page2Width,
                }}
            >
                <Flyer
                    page={props.page2}
                    handleInternalZooming={false}
                    sliderRef={props.sliderRef}
					isSecondPage={!isVerticalScrolling || !props?.isHebrewStyle}
                />
            </Box>

        </Box>
    )
}

export default Flyer2Pages